import React, { useState, useRef, useEffect, useCallback } from 'react';
import { ReactTabulator } from 'react-tabulator';
import DatePicker from "react-datepicker";
import {Card} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import "tabulator-tables/dist/css/tabulator_semanticui.min.css"; 
import { jwtDecode } from 'jwt-decode';
import loader from '../../assets/img/loading.gif'
import Sanc_002_01 from './sanc_002_01'
import { API_BASE_URL } from '../../config/app-axios.jsx';
import { clearUserState } from '../../reducers/userReducers.jsx';
import { clearMenuState } from '../../reducers/menuReducers.jsx';
import { clearLangCodeState } from '../../reducers/langCodeReducers.jsx';

// 결재대기
const Sanc002 = () => {
	const { t, i18n } = useTranslation();
	const dispatch    = useDispatch();
	const oneMonthAgo = new Date();
	const tableRef    = useRef(null);

	// 초기 값
	const [loading, setLoading]                       = useState(false);
	const [startDate, setStartDate]                   = useState(oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1));
	const [endDate, setEndDate]                       = useState(new Date());
	const [rowsPerPage, setRowsPerPage]               = useState(20);
	const [filterField, setFilterField]               = useState('approval_type');
	const [filterType, setFilterType]                 = useState('like');
	const [filterValue, setFilterValue]               = useState('');
	const [totalCount, setTotalCount]                 = useState(0);

	// remote 방식에 따른 페이징 처리
	const apiUrl   = API_BASE_URL;
	const userInfo = useSelector(state => state.login.userInfo);
	const token    = userInfo?.access_token;

	// ①. 강제로 쿠키 삭제를 통한 로그인 정보가 없는 경우
    const persistInfo = sessionStorage.getItem('persist:login');

    if (!persistInfo) {
        window.location.href = '/login';
    };

	// ②. 토큰 만료 체크 루틴
	if (token) {
		const decodedToken            = jwtDecode(token);
		const expirationTimeInSeconds = decodedToken.exp;
		const currentTimeInSeconds    = Math.floor(Date.now() / 1000);

		if (expirationTimeInSeconds < currentTimeInSeconds) {
			// 토큰이 만료되었을 경우 로그인 페이지로 리디렉션
			dispatch(clearUserState());
			dispatch(clearMenuState());
			dispatch(clearLangCodeState());
			localStorage.removeItem('langCodeInfo');
			window.location.href = '/login';
		};
	};

	// Tabulator columns 목록
	const sanc002Columns = (t) => {
		return[
			{formatter:"rowSelection", titleFormatter:"rowSelection", headerHozAlign: 'center', hozAlign:"center", headerSort:false, width:30, cellClick:function(e, cell){
				cell.getRow().toggleSelect();
			}},
			{ title: t('APPROVAL.요청일', { defaultValue: '요청일' }), field: 'created_date', headerHozAlign: 'center', hozAlign: 'center', width:180, formatter:function(cell, formatterParams, onRendered){
				var value = cell.getValue();
					value = moment(value).format("DD/MM/YYYY HH:mm:ss");
				return value;
			} },
			{ title: t('LOAN_APPLICATION.대출예정일', { defaultValue: '대출예정일' }), field: 'loan_date', headerHozAlign: 'center', hozAlign: 'center', width:180, formatter:function(cell, formatterParams, onRendered){
				var value = cell.getValue();
				value = moment(value).format("DD/MM/YYYY");
			return value;
			} },			
			// { title: '결재명', field: 'loan_status', headerHozAlign: 'center', hozAlign: 'center', width:200 },
			{ title: t('APPROVAL.결재명', { defaultValue: '결재명' }), field: 'approval_type', headerHozAlign: 'center', hozAlign: 'center', width:160 },
			// { title: `<i class="fa-solid fa-link"></i> ${t(`APPROVAL.대출접수번호`, { defaultValue: '대출접수번호' })}`, field: 'loan_application_id', headerHozAlign: 'center', hozAlign: 'center', width: 200 ,
			// 	formatterParams:{
			// 		urlPrefix:"/loan/loan_002?loanApplicationId=", // URL 커스텀
			// 	},
			// 	formatter: function(cell, formatterParams, onRendered){
			// 		let value = cell.getValue();
			// 		let href = `${formatterParams["urlPrefix"]}${value}`;
			
			// 		// 모바일 환경에서는 href 이동을 막음
			// 		let isMobile = window.innerWidth <= 768; // 예시: 화면 폭이 768px 이하면 모바일로 간주
			// 		let clickEvent = isMobile ? 'return false;' : ''; // 모바일이면 클릭 이벤트를 막음
			
			// 		return `<a href="${href}" style="text-decoration: none; font-weight: bold; color: green;" onclick="${clickEvent}">${value}</a>`;
			// 	}
			// },
			{ title: `<i class="fa-solid fa-link"></i> ${t(`APPROVAL.대출접수번호`, { defaultValue: '대출접수번호' })}`, field: 'loan_application_id', headerHozAlign: 'center', hozAlign: 'center', width: 200 ,
				formatter: function(cell){
					let value = cell.getValue();
					let displayValue = value.slice(0, 6) + '-' + value.slice(6, 9) + '-' + value.slice(9, 15) + '-' + value.slice(15);

					return `<span style="cursor:pointer; font-weight:bold; color:green; text-decoration:underline;">${displayValue}</span>`;
				},
				cellClick: function(e, cell) {
					const value = cell.getValue();
					// App 레이아웃 없는 standalone 페이지 열기
					const url = `/loan/loan_002_06?loanApplicationId=${value}`;
					const width = 1200;
					const height = 800;

					// 화면 크기 가져오기
					const screenWidth = window.screen.width;
					const screenHeight = window.screen.height;

					// 가운데 위치 계산
					const left = (screenWidth - width) / 2;
					const top = (screenHeight - height) / 2;

					// 팝업 열기
					window.open(
						url,
						"_blank",
						`width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
					);
			}
			},
			{ title: t('APPROVAL.대출자', { defaultValue: '대출자' }), field: 'name', headerHozAlign: 'center', hozAlign: 'center', width:160 },
			{ title: t('APPROVAL.대출금액', { defaultValue: '대출금액' }), field: 'loan_amount', headerHozAlign: 'center', hozAlign: 'right', width:150, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } },
			{ title: `<i class="fa-solid fa-link"></i> ${t(`APPROVAL.결재상태`, { defaultValue: '결재상태' })}`, field: 'approval_status', headerHozAlign: 'center', hozAlign: 'center', width:160 ,
				formatter: function (cell, formatterParams, onRendered) {
					const codeName = cell.getValue();
					cell.getElement().style.fontWeight = 'bold';

					if (codeName === t(`APPROVAL.결재완료`, { defaultValue: '결재완료' })) {
						cell.getElement().style.color = 'rgba(41, 41, 202, 0.861)';
					}

					if (codeName === t(`APPROVAL.거절`, { defaultValue: '거절' })) {
						cell.getElement().style.color = 'rgba(202, 41, 41, 0.861)';
					}

					return codeName;
				},
				cellClick:function(e, cell){
					// 모바일 환경에서는 모달 열기 금지
					if (window.innerWidth <= 768) {
						e.preventDefault();
						return;
					}

					const rowData = cell.getRow().getData();
					handleSanctionClick(rowData);
				},
			},
			{ title: t('APPROVAL.대출상태', { defaultValue: '대출상태' }), field: 'executiontype', headerHozAlign: 'center', hozAlign: 'center', width:160 },
			{ title: t('APPROVAL.결재요청자', { defaultValue: '결재요청자' }), field: 'request_user_name', headerHozAlign: 'center', hozAlign: 'center', width:160 },
			{ title: t('APPROVAL.결재실행자', { defaultValue: '결재실행자' }), field: 'approve_user_name', headerHozAlign: 'center', hozAlign: 'center', width:160 },
			// { title: '결재ID', field: 'approval_info_id', headerHozAlign: 'center', hozAlign: 'center', width:120 },
		];
	}

	const [columns, setColumns]                       = useState(sanc002Columns(t));

	// i18 선택된 언어에 따라 필요한 필드 값 번역
	const translateItem = useCallback((item, language) => {
		// 원본 approval_status 값을 approval_status_code에 저장
		const approvalStatusCode = item.approval_status;
	
		// 번역된 값으로 approval_status 업데이트
		const translatedItem = {
			...item,
			executiontype   : item.executiontype ? t(`CODE_INFORMATION.${item.executiontype}`, { lng: language }) : '',
			approval_type   : item.approval_type ? t(`APPROVAL_TYPE.${item.approval_type}`, { lng: language }) : '',
			approval_status : item.approval_status ? t(`APPROVAL_STATUS.${item.approval_status}`, { lng: language }) : '',
		};
	
		// 원본 approval_status 값을 approval_status_code에 저장
		translatedItem.approval_status_code = approvalStatusCode;
	
		return translatedItem;
	}, [t]);

	// 모달폼오픈
	const [showModal, setShowModal]            = useState(false);

	const [approvalDetail , setApprovalDetail] = useState('');

	// Cell 클릭 이벤트(결재)
	const handleSanctionClick = (rowData) => {
		setApprovalDetail(rowData);
		handleModalOpen();
	};
	
	// 모달창오픈
	const handleModalOpen = () => {
		setShowModal(true);
	};

	// 모달창닫고, 재조회 
	const handleClose = () => {
		setShowModal(false);
		handleQuery();
	};

	// 시작일 값 변경
	const handleChangeStartDate = (date) => {
		setStartDate(date);
	};

	// 종료일 값 변경
	const handleChangeEndDate = (date) => {
		setEndDate(date);
	};

	// Tabulator Options
	// options 객체를 상태로 관리
	const [options, setOptions] = useState({
		ajaxURL     : `${apiUrl}/sanc/sanc_002`,
		ajaxConfig  : {
			method  : 'GET',
			headers : {
				'Content-Type' : 'application/json',
				'Authorization': `Bearer ${token}`,
			},
		},
		ajaxParams : {
			startDate : moment(startDate).format('YYYY-MM-DD'),
			endDate   : moment(endDate).format('YYYY-MM-DD'),
			page      : tableRef.current && tableRef.current.table ? tableRef.current.getPage() : 1,
			size      : tableRef.current && tableRef.current.table ? tableRef.current.getPageSize() : 20, // 페이지 크기 정보
		},
		layout                 : "fitColumns",
		pagination             : true,
		paginationMode         : "remote",
		paginationSize         : rowsPerPage,
		paginationSizeSelector : [20, 40, 60, 80, 100],
		ajaxResponse : function (url, params, response) {

			const total_count    = response.total_count || 0;
			const translatedData = response.data.map(item => translateItem(item, i18n.language));
			const responseData   = {
				last_page : response.last_page,
				data      : translatedData,
			};

			setTotalCount(total_count);

			return responseData;
		}
	});

	// 로딩 중일 때 이전의 pagination 관련 정보를 유지하도록 설정
	const loadingOptions = {
		pagination             : true,
		paginationMode         : "remote",
		paginationSize         : rowsPerPage, // 이전 페이지 사이즈를 유지
		paginationSizeSelector : [20, 40, 60, 80, 100],
	};

	// 조회 버튼 작동 시 실행되는 함수
	const handleQuery = useCallback(
		async () => {
			setLoading(true);

			// ReactTabulator의 내부 로직을 사용하여 API 호출
			try {
				// ReactTabulator에서 사용하는 API URL과 Params를 사용하여 호출
				const url  = new URL(options.ajaxURL);
				url.search = new URLSearchParams({
					...options.ajaxParams,
					page         : tableRef.current?.getPage(),     // 현재 페이지 정보
					size         : tableRef.current?.getPageSize(), // 페이지 크기 정보
				});

				const data = await fetch(url, {
					method  : options.ajaxConfig.method,
					headers : options.ajaxConfig.headers,
				});

				const responseData = await data.json();

				// 전달 받은 총 데이터 건수
				const total_count = responseData.total_count || 0;
		
				// 번역이 필요한 부분
				const translatedData = responseData.data.map(item => translateItem(item, i18n.language));
		
				// 페이징 및 데이터 리턴
				const updatedData = {
					last_page : responseData.last_page, // 전체 페이지 수 계산
					data      : translatedData, // 실제 테이블 데이터
				};

				// 총 건수를 화면에 표현하기 위해서
				setTotalCount(total_count);

				// 데이터 변경
				if (tableRef.current) {
					tableRef.current.setData(updatedData.data || []);
				}

				setLoading(false);

			} catch (error) {
				console.error('Error in fetchSanc002Data : ', error);
				setLoading(false);
			} 
		}, [options, i18n.language, translateItem]
	);

	// 조회 조건이 바뀜에 따라 ajaxParams 동적 변경
	useEffect(() => {
		setOptions((prevOptions) => {
			const updatedOptions = {
				...prevOptions,
				ajaxParams: {
					...prevOptions.ajaxParams,
					startDate               : moment(startDate).format('YYYY-MM-DD'),
					endDate                 : moment(endDate).format('YYYY-MM-DD'),
				},
			};
			return updatedOptions;
		});
	}, [startDate, endDate]);

	// Filter 값에 따른 Tabulator 변화가 일어나는 함수
	const updateFilter = () => {
		if (tableRef.current) {
			tableRef.current.setFilter(filterField, filterType, filterValue);
		}
	};

	// value값을 입력할 때마다 해당되는 Tabulator가 화면에 보이도록 함수호출하는 부분
	const handleKeyUp = () => {
		updateFilter();
	};

	useEffect(() => {
		setColumns(sanc002Columns(t))
	}, [i18n.language, t]);

	// UI
	return (
		<Card style={{ height: '100%' }}>
			<Card.Header><strong>{t('APPROVAL.결재대기', { defaultValue: '결재대기' })}</strong></Card.Header>
			<Card.Body className='responsive-card-body'>
				<div className="panel-body">
					{/* <form action="/" method="POST"> */}
						<div className="row ms-0">
							<div className="form-group col-lg-3 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
								<label className="form-label" htmlFor="date_id">
									<i className="bi bi-calendar3"></i> {t('APPROVAL.요청일', { defaultValue: '요청일' })}
								</label>

								<div className="input-group input-daterange">
									<div className='col'>
										<DatePicker
											className='form-control'
											selected={startDate}
											onChange={handleChangeStartDate}
											dateFormat="dd/MM/yyyy"
										/>
									</div>

									<div className="col-auto">
										<span className="input-group-text input-group-addon"> ~ </span>
									</div>

									<div className='col'>
										<DatePicker
											className='form-control'
											selected={endDate}
											onChange={handleChangeEndDate}
											dateFormat="dd/MM/yyyy"
										/>
									</div>
								</div>
							</div>

							<div className="form-group col-lg-4 col-md-12 col-xs-12"></div>
							<div className="form-group col-lg-4 col-md-12 col-xs-12"></div>

							<div className="form-group col-lg-1 col-md-12 col-xs-12 ps-0 rounded-2">
								<div className="mb-3"></div>
								<button type="button" className="btn btn-success float-end float-bottom w-100 h-30.5px align-baseline mt-8px" onClick={handleQuery}>{t('LOAN_APPLICATION.조회', { defaultValue: '조회' })}</button>
							</div>


							<div className="mt-3 mb-3 ps-0">
								<i id="filter-icon" className="cursor-pointer fa fa-plus-square" data-bs-toggle="collapse" href="#collapseExample" aria-expanded="false" aria-controls="collapseExample"></i>
								<span> Filter</span>
							</div>

							<div className="collapse show" id="collapseExample">
								<div className="row">
									<div className="form-group col-lg-2 col-md-12 col-xs-12 ps-0 rounded-2 mb-1">
										<select 
											id="filter-field" 
											className="form-select col-sm-3" 
											value={filterField}
											onChange={(e) => setFilterField(e.target.value)}
										>
											<option value="loan_status">{t('APPROVAL.결재명', { defaultValue: '결재명' })}</option>
											<option value="loan_application_id">{t(`APPROVAL.대출접수번호`, { defaultValue: '대출접수번호' })}</option>
											<option value="name">{t('APPROVAL.대출자', { defaultValue: '대출자' })}</option>
											<option value="request_user_name">{t('APPROVAL.결재요청자', { defaultValue: '결재요청자' })}</option>
										</select>
									</div>
						
									<div className="form-group col-lg-2 col-md-12 col-xs-12 ps-0 rounded-2 mb-1">
										<select 
											id="filter-type" 
											className="form-select col-sm-3"
											value={filterType}
											onChange={(e) => setFilterType(e.target.value)}
										>
											<option value="like">LIKE</option>
											<option value="=">=</option>
											<option value="<">&lt;</option>
											<option value="<=">&le;</option>
											<option value=">">&gt;</option>
											<option value=">=">&ge;</option>
											<option value="!=">!=</option>
										</select>
									</div>
						
									<div className="form-group col-lg-8 col-md-12 col-xs-12 ps-0 mb-3 rounded-2">
										<input 
											id="filter-value" 
											type="text" 
											className="form-control col-sm-6" 
											name="filter-value" 
											placeholder={t('COMMON.검색할 내용을 입력하세요', { defaultValue: '검색할 내용을 입력하세요' })}
											value={filterValue}
											onChange={(e) => setFilterValue(e.target.value)}
											onKeyUp={handleKeyUp}
										/>
									</div>
								</div>
							</div>
						</div>
					{/* </form> */}
				</div>

				{/* 로딩 관련 gif */}
				{loading && 
					<div
						style={{
							position: 'fixed',
							top: '50%',
							left: '55%',
							transform: 'translate(-50%, -50%)',
							zIndex: 9999,
						}}
					>
						<img src={loader} alt="Loading..." />
					</div>
				}

				{/* Tabulator */}
				<div id="tabulator-total-info" className='d-flex justify-content-end fw-bold'>{t(`LOAN_APPLICATION.총 {{count}}건`, { count: totalCount, defaultValue: '총 {{count}}건' })}</div>
				<ReactTabulator
					key         = {i18n.language + JSON.stringify(columns) + JSON.stringify(options)} // 언어 변경 및 옵션 변경에 따라 컴포넌트 리렌더링
					onRef       = {(r) => (tableRef.current = r.current)}
					columns     = {columns}
					options     = {loading ? loadingOptions : options} // 로딩 중일 때는 이전의 pagination 관련 정보를 유지하고 데이터를 변경하지 않도록 함
					placeholder = "No Data Found"
					className   = "responsive-tabulator"
				/>
			</Card.Body>
			{/* <div className="card-footer d-flex justify-content-start mt-auto"></div> */}

			<Sanc_002_01 
				showModal={showModal} 
				handleClose={handleClose}
				approvalDetail={approvalDetail}
			/>
		</ Card>
	);
};

export default Sanc002;